import { render, staticRenderFns } from "./data-viewer.vue?vue&type=template&id=ffe490f6"
import script from "./data-viewer.vue?vue&type=script&lang=js"
export * from "./data-viewer.vue?vue&type=script&lang=js"
import style0 from "./data-viewer.vue?vue&type=style&index=0&id=ffe490f6&prod&lang=stylus"
import style1 from "./data-viewer.vue?vue&type=style&index=1&id=ffe490f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports